import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { APIService } from "@utils/apiService";
import { AppConfig } from "@config/config";
import { EmployeeData } from "@utils/types";
import { enqueueSnackbarMessage } from "@slices/commonSlice/common";

export interface EmployeesHistoryState {
  state: "failed" | "success" | "loading" | "idle";
  stateMessage: string | null;
  employees: EmployeeData[];
  errorMessage: string | null;
}

const initialState: EmployeesHistoryState = {
  state: "idle",
  stateMessage: null,
  errorMessage: null,
  employees: []
};

export const getAdditionalLeadEmployees = createAsyncThunk(
  "employeesHistory/getAdditionalLeadEmployees",
  async (additionalManagerEmail: string, { dispatch }) => {
    return new Promise<{
       additionalLeadEmployees: EmployeeData[];
    }>((resolve, reject) => {
      APIService.getInstance()
        .get<{
           employees: EmployeeData[];
        }>(
          AppConfig.serviceUrls.retrieveEmployeeList +
          "?additionalManagerEmail=" +
          additionalManagerEmail
        )
        .then((resp) => {
          resolve({
            additionalLeadEmployees: resp.data.employees,
          });
        })
        .catch((error: any) => {
          dispatch(
            enqueueSnackbarMessage({
              message:
                error.response?.status === 500
                  ? String(error.response?.data.message)
                  : "Unable to load employees",
              type: "error",
            })
          );
          reject(error);
        });
    });
  }
);

export const EmployeesHistory = createSlice({
  name: "lead-employees-promotion-history",
  initialState,
  reducers: {
    reset: (state) => {
      state.state = "idle";
      state.stateMessage = "";
      state.employees = [];
    },
    setStateMessage: (state, action: PayloadAction<string>) => {
      state.stateMessage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdditionalLeadEmployees.pending, (state, action) => {
        state.stateMessage = "Loading Promotion Requests";
        state.state = "loading";
      })
      .addCase(getAdditionalLeadEmployees.fulfilled, (state, action) => {
        state.employees = action.payload.additionalLeadEmployees;
        state.state = "success";
      })
      .addCase(getAdditionalLeadEmployees.rejected, (state, action) => {
        state.state = "failed";
      })
  },
});

export const { reset, setStateMessage } = EmployeesHistory.actions;

export default EmployeesHistory.reducer;
